module.exports = __webpack_public_path__ + "static/media/cincinnati-logo.8d9d04a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/cincinnati-logo.png
// module id = 606
// module chunks = 0